<template>
  <div class="col-lg-6">
    <div class="tabset" style="padding: 10px;">
      <!-- Tab 1 -->
      <span>
        <input type="radio" name="tabset" id="tab1" aria-controls="marzen" checked @click="changeradio('marzen')" />

        <label for="tab1" class="mb-0"> Edit Profile </label></span>
      <!-- Tab 2 -->
      <span><input type="radio" name="tabset" id="tab2" aria-controls="rauchbier"  @click="changeradio('rauchbier')"/>

        <label for="tab2" class="mb-0"> Change Password</label></span>
      <!-- Tab 3 --><span>
        <input type="radio" name="tabset" id="tab3" aria-controls="dunkles" @click="changeradio('dunkles')" />
        <label for="tab3" class="mb-0"> Booking History </label></span>

      <div class="tab-panels">
        <section id="marzen" class="tab-panel pt-15" v-if="radio=='marzen'">
          <div class="membership">
            <form>
              <div class="form-group">
                <input type="text" placeholder="
 Name "   />
              </div>
              <!-- end form-group -->
              <div class="form-group">
                <input type="text" placeholder="Your E-mail"   />
              </div>
              <div class="form-group">
                <input type="text" placeholder="Your Mobile No"  />
              </div>
              <div class="form-group">
                <input type="submit" value="Continue " />
              </div>
            </form>
          </div>
        </section>
        <section id="rauchbier" class="tab-panel pt-15" v-if="radio=='rauchbier'">
          <div class="membership">
            <form  @submit.prevent="changePwd">
              <!-- end form-group -->
              <div class="form-group">
                <input type="password" placeholder="New Password * "  v-model="pwd.pwd"/><i class="lni lni-eye"></i>
              </div>

              <div class="form-group">
                <input type="password" placeholder="
Retype Password *" v-model="pwd.confirm"  /><i class="lni lni-eye"></i>
              </div>
              <!-- end form-group -->

              <!-- end form-group -->
              <div class="form-group">
                <input type="submit" :value="pwd.clicked?'Processing':'Save'"  :disabled="pwd.clicked" />
              </div>
              <div class="text-warning" v-html='pwd.error'></div>

              <!-- end form-group -->

              <!-- end or -->
            </form>
          </div>
        </section>

        <section id="dunkles" class="tab-panel pt-15" v-if="radio=='dunkles'" >
          <div v-if="bookings">
          <div  v-for="(booking,index) in bookings" :key="index">
          <p style="margin-bottom: 5px">
            <strong>{{ booking.stime }}</strong>
          </p>
          <div>{{ booking.co_movie }}</div>
 
          <p style="margin-bottom: 0px; font-weight: 600">{{ booking.co_seat }}</p>
          <p style="margin-bottom: 0px; color: #949494; font-size: 14px">
            Total Fare
          </p>
          <p style="margin-bottom: 5px; font-weight: 600">RS.{{ booking.amount }}</p>
          <div v-if="booking.avbl">
            <a  style="
                background-color: #de186b;
                color: white;
                padding: 8px 9px;
                border-radius: 5px;
                font-size: 12px; 
              " @click="sendMail(booking.res)">
              <i class="fa fa-envelope-o" aria-hidden="true"></i> MAIL
            </a>
            &nbsp;
            <a @click="GotoMticket(booking.res)" style="
                background-color: #de186b;
                color: white;
                padding: 8px 9px;
                border-radius: 5px;
                font-size: 12px;
              ">
              <i class="fa fa-mobile" aria-hidden="true"></i> M Ticket
            </a>
          </div>

          <div style="border-bottom: 1px dashed #df1e6e">&nbsp;</div>
          </div>
        </div>
          <div class="alert alert-danger" v-if="!bookings"> No previous bookings to display</div>

        </section>
      </div>
    </div>
  </div>
  <div class="modal-container" v-html="modalText"></div>
  <!-- end col-7 -->
</template>


<script>
import axios from 'axios';
import { URL } from '@/conf';
export default {
  props:['logincode','mobile','email','name'],

  data: () => ({
radio:"marzen",
bookings:{},
modalText:null,
customer:{
            loginCode:localStorage.getItem("loginCode"),
            mobile:null,
            email:null,
            name:null,},
      pwd:{pwd:null,confirm:null,error:null,clicked:null,code:localStorage.getItem("loginCode")},

  }),
  methods: {
    changeradio(radio) {
      this.radio=radio;
    },
    changePwd(){
  var valid=true;
  var ermsg="";
  if(!this.pwd.pwd){
  valid=false;
    ermsg="Password cannot be empty";  
  }
  if(this.pwd.pwd!=this.pwd.confirm){
    valid=false;
    ermsg="Password and confirm password must be identical";
  }
  if(valid)
      {
        this.pwd.clicked=true;
        axios.post(URL + "updatePwd",this.pwd,{headers: {
                'Content-type': 'application/x-www-form-urlencoded',
              }}).then((response) => {
        this.pwd.clicked=false;
               if(response.data.status=="done")
               {
                this.pwd={};
                this.pwd.code=localStorage.getItem("loginCode");
           }else if(response.data.status=="error")
               {
this.pwd.error=response.data.msg;
               }else{
            this.pwd.error="Something went wrong";
           }
            }).catch(()=>{
      
            })}else{
              this.pwd.error=ermsg;
            }
},
getBookings(){
axios.get(URL + "bookHistory?code="+localStorage.getItem("loginCode")).then((response) => {
if(response.data.status=="done")
{
  this.bookings=response.data.tickets;
}
})
},
sendMail(resno){
  this.showModal=true;
  this.modalText="<div class='text-danger'>Please wait</div>";
  var that=this;
  axios.post(URL + "sendMail",{"res":resno},{headers: {
                'Content-type': 'application/x-www-form-urlencoded',
              }}).then((response) => {
                if(response.data.msg)
               {
                this.modalText=response.data.msg;
               }
               setTimeout(function () {
                 that.showModal=false;
                 that.modalText=null;
               },3000)
              });
},
GotoMticket(resno){
  this.$router.push("../bookingsuccess/"+resno);
}

  },
  mounted(){
    this.getBookings();
  }
}

</script>
<style></style>